import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            分类浏览
          </h2>
          <p className="text-sm text-foreground-600 mt-2">
            按题材分类浏览，快速找到感兴趣的里番动漫内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex items-start gap-4 p-5 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-12 h-12 flex-shrink-0 rounded-lg flex items-center justify-center ${
                cat.color === 'primary' ? 'bg-primary-100 text-primary-600' :
                cat.color === 'accent' ? 'bg-accent-100 text-accent-700' :
                'bg-secondary-100 text-secondary-700'
              }`}>
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-base font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 mb-1">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-600 line-clamp-2 leading-relaxed">
                  {cat.description}
                </p>
              </div>
              <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center mt-1">
                <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors duration-200"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}